function injectTurnToSpeedFlex () {

	const isTurnToInitialized = window.turnToConfig && document.getElementById('ttSpeedFlexWidgetScript');
	if (!isTurnToInitialized) {

		// TODO: remove hardcoded key and pull it from web.config
		const ttScript = document.createElement('script');
		const ttSku = window.shortSku;
		const ttLocale = 'en_US';
		window.turnToConfig = {
			sku: ttSku,
			pageId: 'pdp-page',
			locale: ttLocale
		};

		window.TurnToCmd =			window.TurnToCmd
			|| function () {

				// eslint-disable-next-line prefer-rest-params
				(window.TurnToCmd.q = window.TurnToCmd.q || []).push(arguments);

			};
		// eslint-disable-next-line max-len
		ttScript.src = `https://widgets.turnto.com/${window.lp.turnTo.speedFlexVersion}/widgets/${window.lp.turnTo.siteKey}/js/turnto.js`;
		ttScript.id = 'ttSpeedFlexWidgetScript';
		document.body.append(ttScript);

	}

}

export default injectTurnToSpeedFlex;
